const DEFAULT_RECOMMENDATION_QUESTION =
    'How likely would you recommend Footprints to your friends and colleagues?';
const DEFAULT_RIGHT_QUESTION = 'What can we do for a better recommendation from you?';
const DEFAULT_WRONG_QUESTION = 'Please tell us what you like most about Footprints.';
const DEFAULT_RATING_THRESHOLD = 9;

const textOrDefault = (value, fallback) => {
    if (typeof value !== 'string') return fallback;
    const trimmed = value.trim();
    return trimmed || fallback;
};

export const getSurveyCopy = (constants = {}) => {
    const rawThreshold = Number(constants.surveyRatingThreshold);
    const ratingThreshold = Number.isFinite(rawThreshold)
        ? rawThreshold
        : DEFAULT_RATING_THRESHOLD;

    return {
        recommendationQuestion: textOrDefault(
            constants.surveyRecommendationQuestion,
            DEFAULT_RECOMMENDATION_QUESTION
        ),
        rightQuestion: textOrDefault(constants.surveyRightQuestion, DEFAULT_RIGHT_QUESTION),
        wrongQuestion: textOrDefault(constants.surveyWrongQuestion, DEFAULT_WRONG_QUESTION),
        ratingThreshold,
    };
};
